export const updateTargetedOfferPill = ({updateState, targetedOffersPillShow}) => {
    updateState({
      targetedOffersPillShow,
    });
  };